import React, {useMemo} from 'react';
import AurDialog, {DialogProps} from '../../../common/aur-dialog/AurDialog';
import {t} from 'i18next';

export type CustomConfirmDialogType = 'close' | 'rename';

export interface CustomConfirmDialogProps extends DialogProps {
  confirmType?: CustomConfirmDialogType;
}

const CustomConfirmDialog: React.FC<CustomConfirmDialogProps> = ({
  confirmType,
  ...rest
}) => {
  const context = useMemo(() => {
    if (confirmType === 'rename') {
      return {
        title: t('fieldManagement.customField.renameConfirmDialog.title'),
        labelCancel: t('buttons.cancel'),
        labelOk: t('buttons.continue'),
      };
    }

    return {
      title: t('fieldManagement.customField.closeConfirmDialog.title'),
      subtitle: t('fieldManagement.customField.closeConfirmDialog.subtitle'),
      labelCancel: t('common.stayOnPanel'),
      labelOk: t('common.yesClostIt'),
    };
  }, [confirmType]);

  return (
    <AurDialog
      dialogTitle={t('common.justToConfirm')}
      popupTitle={context.title}
      popupContent={context?.subtitle}
      labelActionCancel={context.labelCancel}
      labelActionOk={context.labelOk}
      {...rest}
    />
  );
};

export default CustomConfirmDialog;
